"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.letterSpacing = void 0;
exports.letterSpacing = {
    letterSpacing0: 0,
    letterSpacing1: 0.25,
};
//# sourceMappingURL=letterSpacing.js.map